export default __webpack_public_path__ + "static/media/Tamarin Battle Ward.9e9b7827.jpg";